import React from 'react'
import LayoutClassic from 'components/layouts/layoutClassic'
import Breadcrumb from 'components/blog/breadcrumb'
import CardCaseStudy from 'components/cards/cardCaseStudy'
import { COMMON } from 'utils/intl/common'

function CaseStudiesPage(props) {
  const { nodes } = props.data.page
  const dataFooter = props.data.footer.data
  const dataHeader = props.data.header.data

  const PAGE_CASE_STUDIES = 'Case Studies'

  return (
    <LayoutClassic
      title={PAGE_CASE_STUDIES}
      description={PAGE_CASE_STUDIES}
      dataFooter={dataFooter}
      dataHeader={dataHeader}
      headerIsTransparent
    >
      <div className="page__bg-white">
        <div className="hero-small hero--authors hero--dark">
          <Breadcrumb title={PAGE_CASE_STUDIES} className="is-dark has-border" />
          <div className="container">
            <div className="row">
              <div className="col col-md-10 col-lg-5 col--center">
                <div className="hero__title mt-3">
                  <div className="hero__title__content ft-center">
                    <h1 className="c-white mb-3">{COMMON.TITLE_SECTION_CASE_STUDIES}</h1>
                    <p className="c-white mb-0">{COMMON.DESCRIPTION_SECTION_CASE_STUDIES}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col col-md-10 col--center mt-6 mb-10">
              <div className="mosaic mosaic--3 mosaic--gap-3">
                {nodes.map((currentData, index) => (
                  <CardCaseStudy key={index} index={index} slug={currentData.uid} data={currentData} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </LayoutClassic>
  )
}

export default CaseStudiesPage
